import React, { FC } from "react";
import styled from "styled-components";
import AmpHeaderToc from "~/components/modules/qaFixedHeader/AmpHeaderToc";
import {
  QaFixedHeaderContainerBase,
  QaFixedHeaderInner,
  QaFixedHeaderProps,
  QaFixedHeaderTitle,
  QaFixedHeaderTitleLink,
} from "~/components/modules/qaFixedHeader/QaFixedHeader";
import QuestionButton from "~/components/modules/qaFixedHeader/QuestionButton";

const AmpQaFixedHeader: FC<QaFixedHeaderProps> = ({
  filteredQuestionContent,
  increaseFeedbackHelpfulUrl,
  lineShareUrl,
  questionAnswer,
  topic,
  twitterShareUrl,
}) => {
  return (
    <>
      <Container id="amp-qa-header">
        <QaFixedHeaderInner className="content-full-wrap">
          <QaFixedHeaderTitle>
            <QaFixedHeaderTitleLink
              href="#page-top"
              className="limited-line--2"
            >
              {filteredQuestionContent}
            </QaFixedHeaderTitleLink>
          </QaFixedHeaderTitle>
          <AmpHeaderToc
            increaseFeedbackHelpfulUrl={increaseFeedbackHelpfulUrl}
            lineShareUrl={lineShareUrl}
            questionAnswer={questionAnswer}
            twitterShareUrl={twitterShareUrl}
          />
          <QuestionButton topic={topic} />
        </QaFixedHeaderInner>
      </Container>

      <amp-position-observer
        target="qa-title"
        viewport-margins="0"
        intersection-ratios="0"
        on="enter:hideHeader.start; exit:showHeader.start;"
        layout="nodisplay"
      ></amp-position-observer>

      <amp-animation id="showHeader" layout="nodisplay">
        <script
          type="application/json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              animations: [
                {
                  keyframes: [
                    {
                      transform: "translateY(0)",
                    },
                  ],
                  selector: "#amp-qa-header",
                },
                {
                  keyframes: [
                    {
                      transform: "translateY(0)",
                    },
                  ],
                  selector: "#qa-header-toc-card",
                },
                {
                  keyframes: [
                    {
                      transform: "translateY(0)",
                    },
                  ],
                  selector: "#qa-header-toc-backdrop",
                },
              ],
              direction: "alternate",
              duration: "150ms",
              fill: "both",
              iterations: "1",
            }),
          }}
        />
      </amp-animation>
      <amp-animation id="hideHeader" layout="nodisplay">
        <script
          type="application/json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              animations: [
                {
                  keyframes: [
                    {
                      transform: "translateY(-100%)",
                    },
                  ],
                  selector: "#amp-qa-header",
                },
                {
                  keyframes: [
                    {
                      transform: "translateY(-100%)",
                    },
                  ],
                  selector: "#qa-header-toc-card",
                },
                {
                  keyframes: [
                    {
                      transform: "translateY(-100%)",
                    },
                  ],
                  selector: "#qa-header-toc-backdrop",
                },
              ],
              direction: "alternate",
              duration: "100ms",
              fill: "both",
              iterations: "1",
            }),
          }}
        />
      </amp-animation>
    </>
  );
};

const Container = styled(QaFixedHeaderContainerBase)`
  @media only screen and (min-width: 992px) {
    visibility: hidden;
  }
`;

export default AmpQaFixedHeader;
